// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"5df8c4a5","739":"2a67d43d"}[chunkId] + ".chunk.js";
};